<template>
    <select
        :id="param"
        :name="param"
        v-model="val"
        class="form-control form-control-lg bg-light"
    >
        <option></option>
        <option>Book now</option>
        <option>Buy</option>
        <option>Call us now at</option>
        <option>Click here</option>
        <option>Click the buy button now</option>
        <option>Come see us at</option>
        <option>Click to download</option>
        <option>Click here for more info</option>
        <option>Download</option>
        <option>Download now</option>
        <option>Get Quote</option>
        <option>Learn more at</option>
        <option>Order now</option>
        <option>Preorder</option>
        <option>Read more</option>
        <option>Reserve</option>
        <option>Join</option>
        <option>Sign up</option>
        <option>Sign in</option>
        <option>Subscribe</option>
        <option>Visit us online at</option>
    </select>
</template>

<script>
export default {
    name: "InputCallToAction",
    props: ["param", "value"],
    data: function() {
        return {};
    },

    computed: {
        val: {
            get: function() {
                return this.value;
            },
            set: function(newValue) {
                this.$parent.progress = true;
                this.$parent.update(this.param, newValue);
            },
        },
    },
};
</script>
